/**
 * @file 活动列表
 * @author caiguoqing
 */

import axiosInstance from "./axiosInstance";

// 获取所有campaign todo列表
export const getCampaignTodoApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/campaign/v3/todo`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// budget 继续投放
export const continueBudgetApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/continue`,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// budget 调整投放
export const changeBudgetApi = async (
  campaignId: string,
  budgetLimitMonthly: number,
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/change`,
      {
        budgetLimitMonthly,
      },
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// budget 取消投放
export const cancelBudgetApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/cancel`,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取campaign 报告
export const getCampaignReportApi = async (params: any) => {
  const { campaignId } = params;
  let url = `/ads/campaign/${campaignId}/report`;

  if (params.marketingStrategy) {
    url = `/ads/campaign/${campaignId}/report?marketingStrategy=${params.marketingStrategy}`;
  }

  try {
    const response = await axiosInstance.post(url, {
      ...params,
      getBudget: true,
    });
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取campaign 报告 Filter
export const getCampaignReportFilterApi = async (params?: any) => {
  const { campaignId, cycleId } = params;
  let url = `/ads/campaign/${campaignId}/report/filter?cycleId=${cycleId}`;

  if (params.marketingStrategy) {
    url = `/ads/campaign/${campaignId}/report/filter?cycleId=${cycleId}&marketingStrategy=${params.marketingStrategy}`;
  }

  try {
    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// getCampaignBudgetInfoApi 报告
export const getCampaignBudgetInfoApi = async (params: any) => {
  const { campaignId, marketingStrategy, cycleId } = params;
  const param = {
    cycleId,
  };
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/budgetInfo?marketingStrategy=${marketingStrategy}`,
      param,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 确认修改最大cpm
export const changeMaxCpmApi = async (
  campaignId: string,
  params: { change: boolean },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/changeMaxCpm`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// review campaign 拒绝或者通过
// approve true 通过 false 拒绝
export const reviewCampaignApi = async (
  campaignId: string,
  params: { approve: boolean; reason?: string },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/review`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 删除campaign
export const deleteCampaignApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/remove`,
      {},
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// campaign 反馈
export const campaignFeedbackApi = async (
  campaignId: string,
  params: { text: string },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/feedback/campaign/${campaignId}`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// campaign 暂停
export const campaignPauseApi = async (campaignId: string, params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/pause`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// campaign 重启
export const campaignSimpleUpdateApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/resume`,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// campaign 更换预算套餐
export const campaignUpdateBudgetApi = async (
  campaignId: string,
  params: {
    budgetLimitMonthly?: number;
    affiliateBudget?: number;
    salesOutreachBudget?: number;
  },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/updateBudget`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 修改campaign 部分数据
export const setUpCampaignPartDataApi = async (
  campaignId: string,
  params: any,
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v2/${campaignId}/updatePartial`,
      params,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 下载report
export const downloadReportApi = async (campaignId: string, params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/report/download`,
      params,
      { responseType: "blob" },
    );
    return response;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 复制campaign
export const copyCampaignApi = async (params: { campaignId: string }) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v4/duplicate`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 获取 campaign 进度
export const getCampaignProgressApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/v2/${campaignId}/progress`,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 获取 campaign 进度
export const getMismatchedInfluencersListApi = async (
  campaignId: string,
  params: any,
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/mismatchedApplied`,
      params,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message || error?.error);
  }
};
// 保留创作者
export const keepInfluencersApi = async (
  campaignId: string,
  params: {
    orderIds: string[];
  },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/mismatchedApplied/keep`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message || error?.error);
  }
};
// 拒绝创作者
export const rejectInfluencersApi = async (
  params: {
    campaignId: string;
    orderIds: string[];
    reason: string[];
  },
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/mismatch/batchReject`,
      params,
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message || error?.error);
  }
};
